<div class="container-fluid">
  <app-page-header
    title="Gerar Contatos"
    icon="fas fa-users"
    subtitle="Filtre e gere listas de contatos para atendimento">
  </app-page-header>

  @if(!podeVer && !podeEditar){
    <app-no-access></app-no-access>
  }@else{
    <app-create-contact-list-filter></app-create-contact-list-filter>
    <app-create-contact-list-table></app-create-contact-list-table>
  }
</div>
